<template>
	<div class="events">
		<div class="container" v-if="event.title !== ''">
			<div class="row mt-4 mb-4">
				<div class="col-12">
					<img :src="event.image" :alt="event.title" style="width: 100%; border-radius: 5px;">
				</div>
				<div class="col-12 mt-4">
					<div class="row">
						<div class="col-12 col-md-9">
							<h5><b>{{event.org_name}}</b> presents</h5>
							<h1 style="font-family: 'Vidaloka', serif;"><b>{{event.title}}</b></h1>
							<div style="display: flex; ">
								<p style="background: #1c1c1c; padding: 10px 20px; border-radius: 5px; margin-right: 5px;"><i class="fas fa-calendar"></i> <b>{{event.start_date | moment("MMMM Do YYYY")}} {{event.start_time | moment("hh:mm a")}}</b></p>
								<p style="padding: 10px 10px; border-radius: 5px; margin-right: 5px;"><b>to</b></p>
								<p style="background: #1c1c1c; padding: 10px 20px; border-radius: 5px;"> <i class="fas fa-clock"></i> <b>{{event.end_date | moment("MMMM Do YYYY")}}  {{event.end_time | moment("hh:mm a")}}</b></p>
							</div>
						</div>
						<div class="col-12 col-md-3 text-center">
							<div class="mt-5" v-if="event.status ==='Live'">Live {{calendar_start | moment("from", "now")}} <br></div>
							<div class="mt-5" v-else-if="event.status === 'past'">Event ended {{calendar_end | moment("from", "now")}} <br></div>
							<div class="mt-5" v-else>Live {{calendar_start | moment("from", "now")}} <br></div>
							<div v-if="user.id !== event.host.id">
								<a
									v-if="event.registered_status === 'REGISTERED' && user.id !== '' && event.status !== 'past'"
									class="addeventatc btn btn-primary btn-lg text-dark"
									target="_blank"
									:href="'https://calendar.google.com/calendar/r/eventedit?text='+ event.title +'&dates=' + calendar_start  +'/' + calendar_end +'&details=For+details,+link+here:+https://meetbeans.com/e/' + event.event_id + '&location=meetbeans.com'">
									<i class="fa fa-calendar"></i> Add to calendar
								</a>
								<a
									v-if="event.registered_status === 'REGISTERED' && user.id !== ''"
									class="addeventatc btn btn-primary btn-lg text-dark mt-2"  data-toggle="modal" data-target="#agenda">
									 <b>Auditoriums</b>
								</a>
								<a href="#"
									class="btn btn-primary btn-lg text-dark"
									v-else-if="event.registered_status === 'NOT_LOGIN' && user.id === ''" data-toggle="modal"
									 data-target="#loginModal">
									<b>Register</b>
								</a>
								<button class="btn btn-primary btn-lg text-dark" @click="registerEvent()" v-else-if="event.status !== 'past'">
									<b>Join</b>
								</button>
								<!-- <StripeCard v-if="event.status !== 'past'"></StripeCard> -->
							</div>
							<div v-else>
								<router-link class="btn btn-primary btn-lg text-dark" :to="'/e/' + event.event_id + '/edit'">
									<b>Edit Event</b>
								</router-link>
								<a
									class="addeventatc btn btn-primary btn-lg text-dark mt-2" v-if="event.registered_status === 'REGISTERED' || is_host || is_speaker" data-toggle="modal" data-target="#agenda">
									<b>Auditoriums</b>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12" style="margin: 5% 0;">
					<h4 style="font-family: 'Vidaloka', serif;"><b>About Event</b></h4>
					<p v-html="event.long_desc"></p>
				</div>

				<div class="col-12 text-center" v-if="event.sponsors.length > 0" style="margin: 5% 0;">
					<h4 style="font-family: 'Vidaloka', serif;"><b>Thank you to our sponsors</b></h4>
					<div class="row" style="display: flex; justify-content: center;">
						<div class="col-12 col-sm-2 text-center" v-for="(s, i) in event.sponsors" :key="i" >
							<a :href="s.sponsor_website + '?utm_source=meetbeans.com&&utm_event='+event.title" target="_blank">
								<img :src="s.sponsor_img" alt="" style="border-radius: 50%; height: 100px; width: 100px; margin: 10% 2%">
								<h6 class="text-white"><b>{{s.sponsor_name}}</b></h6>
								<p class="text-muted" style="height: 100px; overflow-y: scroll; overflow-x: hidden;">{{s.sponsor_message}}</p>
							</a>
						</div>
					</div>
				</div>
				<div class="col-12 text-center" style="margin: 5% 0;" v-if="event.speakers.length > 0">
					<h4 style="font-family: 'Vidaloka', serif;"><b>Speakers</b></h4>
					<div class="row" style="justify-content: center">
						<div class="col-12 col-sm-4 col-md-4 col-lg-3 mt-2 mb-2" v-for="(u, index) in event.speakers" :key="index">
							<div class="card mb-2">
								<div class="card-body text-center img__wrap">
									<!-- <div v-if="u.photoURL !== ''" class="img__img">
										<img :src="u.photoURL" :alt="u.name" style="width: 100px; height: 100px; border-radius:12px; margin-bottom: 10px;">
									</div>
									<div v-else class="img__img" >
										<figure :data-user="u.name.charAt(0).toUpperCase()" class="user" style="font-weight: bold;"></figure>
									</div> -->
									
									<div class="img__img" >
										<img :src="u.photoURL" :alt="u.name" style="width: 100px; height: 100px; border-radius:12px; margin-bottom: 10px;">
									</div>
									<div class="img__description_layer">
										<p class="img__description" style="height: 150px; overflow-y: scroll; overflow-x: hidden;">{{u.bio}}</p>
									</div>
									<div>
										<h6 class="mb-0"><b>{{u.name}} <span v-if="u.id === user.id" class="badge badge-danger">You</span></b></h6>
										<small>{{u.designation}} - {{u.company}}</small> <br>
										<small v-if="u.is_keynote" class="text-primary">Keynote Speaker</small>
										<small v-else><div style="height: 25px"></div></small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12" style="margin: 5% 0;">
					<div class="text-center">
						<h4 style="font-family: 'Vidaloka', serif;"><b>Agenda</b></h4>
					</div>
					<div class="row" v-for="(s, i) in event.sessions" :key="i">
						<div class="col-12 col-md-12">
							<div class="card mb-2">
								<div class="card-body">
									<div class="row">
										<div class="col-12 col-md-2" style="text-align: -moz-center;text-align: -webkit-center;">
											<figure :data-letters="i+1" style="font-weight: bold; height: 80px; width: 80px;"></figure>
										</div>
										<div class="col-12 col-md-10">
											<h4 class="mb-0"><b>{{s.session_name}}</b></h4>
											<span v-for="(u, index) in s.speakers" :key="index"><span v-if="index!==0">,</span> {{u.name}} </span>
											<p class="text-muted">{{s.session_description}}</p>
											<small style="margin-top: 15px;">Capacity: {{s.participants}} Seats</small>
											<router-link :to="'/event/' + event.event_id + '/agenda/' + s.session_id" class="btn btn-primary float-right" v-if="event.registered_status === 'REGISTERED' && !is_host && !is_speaker && event.status === 'Live'">Enter In Auditorium</router-link>
											<router-link :to="'/event/' + event.event_id + '/agenda/' + s.session_id" class="btn btn-primary float-right" v-if="is_host || is_speaker">Enter In Auditorium</router-link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12">
					<div class="text-center">
						<h4 style="font-family: 'Vidaloka', serif;"><b>About Meetbeans</b></h4>
					</div>
					<div class="row mt-5 mb-5">
						<div class="col-12 col-md-4 mt-2 mb-2" style="border-right: 1px solid #1B1B1B ">
							<div class="row">
								<div class="col-3">
									<img src="../../assets/table-chair.png" alt="" style="border-radius: 12px;">
								</div>
								<div class="col-9">
									<h6><b>Grab a Seat in auditorium</b></h6>
									<p>Interact with fellow attendees on video while sitting on virtual table like real conference.</p>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 mt-2 mb-2"  style="border-right: 1px solid #1B1B1B ">
							<div class="row">
								<div class="col-3">
									<img src="../../assets/mic.svg" alt="">
								</div>
								<div class="col-9">
									<h6><b>Interact with the Speakers</b></h6>
									<p>Ask questions or general chat with guest speakers super easily in a video chat</p>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 mt-2 mb-2">
							<div class="row">
								<div class="col-3">
									<img src="../../assets/live.svg" alt="">
								</div>
								<div class="col-9">
									<h6><b>Simulcast parallel sessions.</b></h6>
									<p>Live stream all the sessions on youtube and facebook.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal -->
		<div class="modal fade" id="agenda" tabindex="-1" role="dialog" aria-labelledby="agenda" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content" style="background: #000;">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Auditorium</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div style="height: 400px; overflow-y: scroll; overflow-x: hidden;">
							<div v-for="(s, i) in event.sessions" :key="i">
								<div class="col-12 col-md-12">
									<div class="card mb-2">
										<div class="card-body">
											<div class="row">
												<div class="col-12 col-md-3" style="text-align: -moz-center;text-align: -webkit-center;">
													<figure :data-letters="s.sequence_id" style="font-weight: bold; height: 80px; width: 80px;"></figure>
												</div>
												<div class="col-12 col-md-9">
													<h4 class="mb-0"><b>{{s.session_name}}</b></h4>
													<span v-for="(u, index) in s.speakers" :key="index"><span v-if="index!==0">,</span> {{u.name}} </span>
													<p class="text-muted">{{s.session_description}}</p>
													<small style="margin-top: 15px;">Capacity: {{s.participants}} Seats</small>
													<router-link data-dismiss="modal" aria-label="Close" :to="'/event/' + event.event_id + '/agenda/' + s.session_id" class="btn btn-primary float-right" v-if="event.registered_status === 'REGISTERED' && !is_host && !is_speaker && event.status === 'Live'">Enter In Auditorium</router-link>
													<router-link data-dismiss="modal" aria-label="Close" :to="'/event/' + event.event_id + '/agenda/' + s.session_id" class="btn btn-primary float-right" v-if="is_host || is_speaker">Enter In Auditorium</router-link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import StripeCard from "@/components/StripeCard.vue";
  export default {
    name: 'home',
	data() {
      return {
        user: {
          id: ""
        },
        is_host: false,
        is_speaker:false,
        start_date: "",
        end_date: "",
        event: {
          title: ""
        },
	      calendar_start: "",
        calendar_end: ""
      }
    },
    created() {
      this.getEventDetailFunction()
      if (localStorage.getItem('user_info')) {
        this.user = JSON.parse(localStorage.getItem('user_info'))
      }
    },
    components: {
		// StripeCard
    },
    computed: {

    },
    methods: {
      dateTimeStamp(datePass) {
		  datePass = datePass.replace(/-/g,'/')
		//   console.log(datePass)
		var fullDate = new Date(datePass);
        var twoDigitMonth = fullDate.getUTCMonth() + "";
        if (twoDigitMonth == 0){
          twoDigitMonth = "01"
        } else if (twoDigitMonth == 1){
          twoDigitMonth = "02"
        } else if (twoDigitMonth == 2){
          twoDigitMonth = "03"
        } else if (twoDigitMonth == 3){
          twoDigitMonth = "04"
        } else if (twoDigitMonth == 4){
          twoDigitMonth = "05"
        } else if (twoDigitMonth == 5){
          twoDigitMonth = "06"
        } else if (twoDigitMonth == 6){
          twoDigitMonth = "07"
        } else if (twoDigitMonth == 7){
          twoDigitMonth = "08"
        } else if (twoDigitMonth == 8){
          twoDigitMonth = "09"
        }else if (twoDigitMonth == 9){
          twoDigitMonth = "10"
        }else if (twoDigitMonth == 10){
          twoDigitMonth = "11"
        }else if (twoDigitMonth == 11){
          twoDigitMonth = "12"
        }
        var twoDigitDate = fullDate.getUTCDate() + "";
        if (twoDigitDate.length == 1)
          twoDigitDate = "0" + twoDigitDate;
        var twoDigithour = fullDate.getUTCHours() + "";
        if (twoDigithour.length == 1)
          twoDigithour = "0" + twoDigithour;
        var twoDigitMin = fullDate.getUTCMinutes() + "";
        if (twoDigitMin.length == 1)
          twoDigitMin = "0" + twoDigitMin;
        var currentDate = fullDate.getFullYear() + twoDigitMonth + twoDigitDate + "T" + twoDigithour  + twoDigitMin +"00"+ "Z";
        // var currentDate = fullDate.getUTCFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + " " + twoDigithour +":"+ twoDigitMin + " " +'AM';
        console.log(fullDate.getUTCFullYear())
        return currentDate
      },
      getEventDetailFunction: function () {
        let data = {
          "event_id": this.$route.params.id,
        }
        this.$store.dispatch('getEventDetail', data).then(resp => {
          if (resp.data.status === "success") {
						this.event = resp.data.data;
						// console.log('event date: ', this.event);
	          this.calendar_start = this.dateTimeStamp(this.event.start_date + ' ' + this.event.start_time)
            this.calendar_end = this.dateTimeStamp(this.event.end_date + ' ' + this.event.end_time)
	          if (localStorage.getItem('user_info')) {
	            if (this.event.host.id===this.user.id) {
	              this.is_host = true
	            }
	            this.event.speakers.forEach(x=>{
	              if (x.id === this.user.id) {
	                this.is_speaker === true
	              }
	            })
	          }
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: 'error',
			  position: 'top',
			  queue: true
            });
          }
        })
      },
      registerEvent: function () {
        let data = {
          "event_id": this.$route.params.id,
        }
        this.$store.dispatch('registerEvent', data).then(resp => {
          if (resp.data.status === "success") {
            this.$toast.open({
              message: "You have successfully registered",
              type: 'success',
			  position: 'top',
			  queue: true
            });
            this.getEventDetailFunction()
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: 'error',
			  position: 'top',
			  queue: true
            });
          }
        })
      }
    }
  }
</script>

<style scoped>
	[data-user]:before {
		content: attr(data-user);
		display: inline-block;
		font-size: 2.5em;
		width: 100px;
		height: 100px;
		line-height: 2.8em;
		text-align: center;
		border-radius: 12px;
		background: deepskyblue;
		vertical-align: middle;
		color: white;
	}

	/* relevant styles */
	.img__wrap {

	}

	.img__description_layer {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(254, 178, 42, 0.8);
		color: #000;
		visibility: hidden;
		opacity: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		/* transition effect. not necessary */
		transition: opacity .2s, visibility .2s;
	}

	.img__wrap:hover .img__description_layer {
		visibility: visible;
		opacity: 1;
		border-radius: 5px;
	}

	.img__description {
		transition: .2s;
		transform: translateY(1em);
	}

	.img__wrap:hover .img__description {
		transform: translateY(0);
	}
</style>
